import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment'
import { UserTradingSearchRequest } from '../shared/models/users/user-trading-search-request';
import { UserTradingSearchResponse } from '../shared/models/users/user-trading-search-response';

@Injectable({
  providedIn: 'root'
})
export class UserTradesService {

  env = environment;
  apiUrl = this.env.apiurl + 'platform/users/';

  constructor(private http: HttpClient, public router: Router) { }

  public SearchPossibleUserTrades(searchRequest: UserTradingSearchRequest): Observable<any> {
    return this.http.post<any>(this.apiUrl + 'possibletrades', searchRequest , { observe: 'response' })
      .pipe(
        map(res => {
          if (res) {
            if (res.status == 200) {
              return res.body.map((data: any) => new UserTradingSearchResponse().deserialize(data));
            }
          }
        })
      );
  }
}
